module.exports = __webpack_public_path__ + "static/dp-princip-4-541b571d927e3b28b55116cce8782545.svg";